const DataNotFound = (props) => {
    return (
      <div className={`data-not-found ${props?.className || ''}`}>
        <h1>{props.title ? (props.nochange ? props?.title : `No ${props?.title}s`) : 'No Data Found'} </h1>
      </div>
    );
  };
  
  export default DataNotFound;
  